(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ks-checkout-buttons"] && !Shopify.designMode) return;
  try {
    (function () {
    var LINK_SELECTOR = '.custom-ks-checkout-button';
    var PRICE_SELECTOR = '[data-ks-checkout-total]';

    function cartJsUrl() {
      var root = window.theme && window.theme.routes && window.theme.routes.root ? window.theme.routes.root : '/';
      return root + 'cart.js';
    }

    function formatTotal(cents) {
      if (window.theme && typeof window.theme.formatMoney === 'function') {
        return window.theme.formatMoney(cents, window.theme.moneyFormat);
      }
      return (Number(cents) / 100).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }

    function hrefWithToken(href, token) {
      var url = new URL(href, window.location.origin);
      url.searchParams.set('cartToken', token);
      return url.toString();
    }

    function patchMarkup(html, token) {
      return html.replace(/cartToken=[^&"]*/g, 'cartToken=' + encodeURIComponent(token));
    }

    function apply(cart) {
      if (!cart || !cart.token) return;
      var formatted = formatTotal(cart.total_price);

      document.querySelectorAll(LINK_SELECTOR).forEach(function (link) {
        var href = link.getAttribute('href');
        if (!href) return;
        link.setAttribute('href', hrefWithToken(href, cart.token));
      });

      document.querySelectorAll(PRICE_SELECTOR).forEach(function (price) {
        if (!price.closest('.custom-buttons-container')) return;
        price.innerHTML = formatted;
      });

      document.querySelectorAll('template').forEach(function (template) {
        if (!template.innerHTML || template.innerHTML.indexOf('custom-ks-checkout-button') === -1) return;
        template.innerHTML = patchMarkup(template.innerHTML, cart.token);
      });
    }

    function refresh() {
      fetch(cartJsUrl(), { credentials: 'same-origin' })
        .then(function (response) {
          return response.json();
        })
        .then(apply)
        .catch(function () {});
    }

    refresh();
    document.addEventListener('theme:cart:added', refresh);
    document.addEventListener('theme:cart:loaded', refresh);
  })();
  } catch(e) { console.error(e); }
})();

})();
